import { fillAdminCourseDetails } from "../../Pages/AdminCourseManagement/Fills";
import { ajaxRequest } from "../Ajax/ajax";
import { hideModal, successToast } from "../utils";

export var activateTutorForCourse = function(userId, courseId, userName, btn=false){

    const url = '/course/' + courseId.toString() + '/tutor/' + userId.toString() + '/invite'

    const success = function(data){
        successToast(userName + ' wurde der Job als Tutor/-in erfolgreich angeboten', 'Erfolg', 10000, true);
        fillAdminCourseDetails(courseId);
        hideModal('activate-tutor');
    }

    ajaxRequest(url, success, {}, btn)

  }